import React from 'react';
import { Datepicker } from '../../../../../../../../../components/form/Datepicker';
import { useNamespacedTranslation } from '../../../../../../../../../hooks/useNamespacedTranslation';
import { i18Path } from '../../constants';
import { formatDate } from '../../../../../../../../../utils/dateUtils';

export const PurchaseDateFormField: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const t = useNamespacedTranslation(i18Path);
  return (
    <Datepicker
      type="date"
      label={t('form.fields.purchaseDate')}
      placeholder={formatDate(new Date(), 'dd.MM.yyyy')}
      name="purchaseDate"
    />
  );
};
